<template>
    <div class="booking-quote-review" :class="{initializing: !initialized}" >
      <header class="booking-quote-review-property">
        <div v-if="typeof data.listing.media !== 'undefined' && data.listing.media.length">
          <img :src="data.listing.media[0].urls.thumbnail_large" :alt="data.listing.media[0].name" class="cover">
        </div>
        <div>
          <h4 class="font-md wt-md mb-2">{{ data.listing.space_name }}</h4>
          <h5 class="wt-std fg-primary mb-6">
            {{ data.listing.address.full_label }}
          </h5>
        </div>
      </header>

      <h5 class="modal-subheading">Dates &amp; times</h5>

      <div class="content">
        <div v-for="(date, index) in data.days_and_times_formatted">
          <h3 class="fg-primary wt-bold mb-4">
            {{ date.day }}
          </h3>
          <div class="lh-std mb-2">
            <span class="wt-bold fg-mid-grey">
              {{ data.type === 'recce' ? 'Arrival time' : 'Call time' }}:
            </span>
            <span class="wt-std">
              {{ date.time }}
            </span>
          </div>
          <div class="lh-std" :class="{'mb-6': (index+1) !== data.days_and_times_formatted.length}">
            <span class="wt-bold fg-mid-grey">
              Address:
            </span>
            <span class="wt-std">
               {{data.listing.address.full_label}}
            </span>
          </div>
          <hr v-if="(index+1) !== data.days_and_times_formatted.length" class="thin mb-6"/>
        </div>
      </div>
    </div>
  </template>

  <script>
  import BaseModal from '../../Base'

  export default {
    extends: BaseModal,
    props: {
      data: {
        type: Object,
        required: false
      }
    },
    data () {
      return {
        loading: false,
        errors: {},
        activeSection: 'dates-and-times',
        initialized: true,
        insurance_documents: this.$store.getters['user/insuranceDocuments'],
        payment_method: null,
        agree_terms: false
      }
    },
    methods: {
      showHirerTermsModal () {
        window.open("/pdf/hirer-agreement.pdf", '_blank');
      },
    }
  }
  </script>
